module.exports = __webpack_public_path__ + "img/ezzebank-white.f17db246.svg";